var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PlayMode, usePreviewLoop } from 'hx-din-test-2';
import { CirclesSelect } from 'hx-ui';
import { useCustomValidationField } from 'hx-util';
import { StepLayout } from '../step-layout.component';
import { pageImages } from '@/pages/images';
import { NavigationButton, NavigationButtonsContainer, } from '../navigation-button.component';
import { createSvgIcon, Typography, useMediaQuery, useTheme, } from '@mui/material';
import { UserSoundLeft } from '@/components/headphone-check/user-sound-left.component';
import { UserSoundBoth } from '@/components/headphone-check/user-sound-both.component';
import { UserSoundRight } from '@/components/headphone-check/user-sound-right.component';
var SoundLeftIcon = createSvgIcon(_jsx(UserSoundLeft, {}), 'SoundLeft');
var SoundBothIcon = createSvgIcon(_jsx(UserSoundBoth, {}), 'SoundBoth');
var SoundRightIcon = createSvgIcon(_jsx(UserSoundRight, {}), 'SoundRight');
export var HeadphoneCheck = function () {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    var _a = useCustomValidationField({
        validationFieldName: 'headphone-check-valid',
        fieldName: 'headphone-check',
        validationFunction: function (value) {
            return value !== 'both' && value !== 'right';
        },
    }), validate = _a.validate, error = _a.error;
    usePreviewLoop({
        autoPlay: true,
        config: {
            playMode: PlayMode.MonoauralLeft,
        },
    });
    return (_jsx(StepLayout, { image: pageImages.norcInWhichEarDoYouHearTheSound, heading: _jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl leading-10 mb-4" }, { children: "In which ear do you hear the sound?" })), progress: {
            phase: 0,
            step: 4,
        }, content: _jsx("div", __assign({ className: "grid gap-4 px-6 place-items-center" }, { children: _jsx("div", __assign({ className: "grid place-items center" }, { children: _jsx(CirclesSelect, { color: "#EC712E", controllerProps: {
                        name: 'headphone-check',
                        rules: {
                            required: 'Please select an option before continuing',
                            validate: validate,
                        },
                    }, itemStyles: {
                        boxShadow: '0 0 4px 2px #00000022',
                        border: '3px solid var(--circle-select-color)',
                        svg: {
                            stroke: 'var(--circle-select-color)',
                            strokeWidth: 1.5,
                            width: isMobile ? '32px' : '40px',
                            height: isMobile ? '32px' : '40px',
                        },
                        '&[data-state="checked"]': {
                            svg: { stroke: 'white', color: 'white' },
                            border: '3px solid white',
                        },
                        '&:focus': {},
                        '&:hover': {
                            backgroundColor: 'var(--circle-select-color)',
                            svg: { stroke: 'white', color: 'white' },
                            border: '3px solid white',
                            opacity: 0.8,
                        },
                        width: isMobile ? '70px' : '100px',
                        height: isMobile ? '70px' : '100px',
                        margin: isMobile ? '12px' : '16px',
                    }, options: [
                        {
                            value: 'left',
                            label: 'Left',
                            icon: _jsx(SoundLeftIcon, { color: "secondary" }),
                        },
                        {
                            value: 'both',
                            label: 'Both',
                            icon: _jsx(SoundBothIcon, { color: "secondary" }),
                        },
                        {
                            value: 'right',
                            label: 'Right',
                            icon: _jsx(SoundRightIcon, { color: "secondary" }),
                        },
                    ] }) })) })), info: _jsx(_Fragment, { children: !!error && (_jsx("span", __assign({ className: "text-red max-w-72 md:max-w-fit font-medium md:text-lg text-center" }, { children: "Unfortunately, your headphones are not supported by this test." }))) }), nav: _jsx(NavigationButtonsContainer, { children: _jsx(NavigationButton, { type: "back", variant: "outlined", label: "Previous" }) }) }));
};
